import { render, staticRenderFns } from "./ev5-animate-number.vue?vue&type=template&id=0839fabe&scoped=true&"
import script from "./ev5-animate-number.vue?vue&type=script&lang=js&"
export * from "./ev5-animate-number.vue?vue&type=script&lang=js&"
import style0 from "./ev5-animate-number.vue?vue&type=style&index=0&id=0839fabe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839fabe",
  null
  
)

export default component.exports